module.exports = __webpack_public_path__ + "img/mir.5c7aaf66.svg";